import { MouseEvent } from "react";
import MoreIconVertical from "./images/icons/moreIconVertical.svg?react";
import "../buttons.scss";

export const MoreButton = (props: {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  id?: string;
}): JSX.Element => {
  return (
    <button
      id={props.id}
      aria-label="More button"
      className="rg-button more"
      title="Show more options"
      onClick={props.onClick}
    >
      <MoreIconVertical />
    </button>
  );
};
